import React from 'react'
import { Button } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

type Connector = {
  label: string
  id: number
}

type TicketIntegrationConfigurationPropType = {
  connector: Connector
}
export default function TicketIntegrationConfiguration({
  connector,
}: TicketIntegrationConfigurationPropType) {
  return (
    <div className="mt-10">
      <hr />
      <h3>Connect responses directly with {connector.label} tickets</h3>
      <Link to={`/settings/integrations/${connector.id}/#ticket-integrations`}>
        <Button basic>
          <i className="text-grey mr-2 far fa-gear" />
          Configure {connector.label} integrations
        </Button>
      </Link>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/TicketIntegrationConfigurations/index.tsx